export default "__VITE_ASSET__B$QIicvg__"